"use strict";

const BC_PrintPreview = function (EWS) {
    this.EWS = EWS;

    this.Dialog = false;

    this.File = false;
    this.Type = false;
    this.Report = false;
};

BC_PrintPreview.prototype.Load = async function () {
    if (this.Dialog && this.File && this.Type) {
        const me = this;
        const myResult = new ECP.EC_Request("GetPrintPreviewResult");
        myResult.SetReturnType(ECP.EC_ReturnType.Text);

        let grid = "False";
        if (me.Dialog.querySelector("#ews-print-grid").checked) {
            grid = "True";
        }

        myResult.AddRequestVariable("Request", "Print");
        myResult.AddRequestVariable("FileName", me.File, ECP.EC_Verb.Post);

        if (me.Report && me.Report >= 0) {
            myResult.AddRequestVariable("ReportID", me.Report);
        }

        myResult.AddRequestVariable("Type", me.Type);
        myResult.AddRequestVariable("ShowGridLines", grid);

        let breaks = "False";

        if (me.Dialog.querySelector("#ews-print-break").checked) {
            breaks = "True";
        }

        myResult.AddRequestVariable("PageBreaks", breaks);

        myResult.AddRequestVariable("WorksheetIndex", me.Dialog.querySelector("#ews-print-sheet").value || "");

        myResult.AddRequestVariable("HeaderTopLeft", me.Dialog.querySelector("#ews-print-header-top-left").value || "None");
        myResult.AddRequestVariable("HeaderTopRight", me.Dialog.querySelector("#ews-print-header-top-right").value || "None");
        myResult.AddRequestVariable("HeaderBottomLeft", me.Dialog.querySelector("#ews-print-header-bottom-left").value || "None");
        myResult.AddRequestVariable("HeaderBottomRight", me.Dialog.querySelector("#ews-print-header-bottom-right").value || "None");

        myResult.AddRequestVariable("Orientation", me.Dialog.querySelector("#ews-print-orientation").value);
        myResult.AddRequestVariable("PaperSize", me.Dialog.querySelector("#ews-print-size").value);
        myResult.AddRequestVariable("Margin", me.Dialog.querySelector("#ews-print-margin").value);
        myResult.AddRequestVariable("Scale", me.Dialog.querySelector("#ews-print-scale").value);

        myResult.AddRequestVariable("Submit", "True");

        let result = await myResult.Submit();

        if (EC_Fmt.Browser === ECP.Browser.Firefox) {
            result = decodeURIComponent(result);

            if (result.indexOf("../") >= 0) {
                result = result.replace("../", "");
            }

            if (result.indexOf("?") >= 0) {
                me.Dialog.querySelector("#ews-print-preview").src = `${result}&t=${new Date().getTime()}`;
            } else {
                me.Dialog.querySelector("#ews-print-preview").src = `${result}?t=${new Date().getTime()}`;
            }
        } else {
            me.Dialog.querySelector("#ews-print-preview").src = `Controls/PrintPreview.html?file=${result}&t=${new Date().getTime()}`;
        }
    }
};

BC_PrintPreview.prototype.Print = function (file, type, report, master, processUrlCallback) {
    const me = this;

    if (!type) {
        if (file.toLowerCase().indexOf(".xlsx") >= 0) {
            type = "XLSX";
        } else {
            type = "PDF";
        }
    }

    if (EC_Fmt.isMobile) {
        ECP.Dialog.Alert("You can not print from a mobile device.");
    } else if (file.length < 5000) {
        const printArgs = {
            file,
            type,
            report,
            master,
            processUrlCallback
        };

        let hasFilters = "";

        if (document.querySelector(".FiltersSheet")) {
            hasFilters = "True";
        }

        if (document.querySelector(".ecp-printPreview-dialog")) {
            document.querySelector(".ecp-printPreview-dialog").parentNode.style.display = "block";
            return;
        }

        EWS.VerifySession(async () => {
            const myResult = new ECP.EC_Request("GetPrintPreviewResult");
            myResult.AddRequestVariable("Request", "Dialog");
            myResult.AddRequestVariable("HasFilters", hasFilters);

            const result = await myResult.Submit();

            const Dialog = ECP.Dialog.ShowDialog(result.title, result.content, {
                width: 930,
                height: 790,
                cancelButtonTitle: result.cancel,
                confirmButtonTitle: result.print,
                confirmButtonAction(dialog) {
                    if (EC_Fmt.Browser !== ECP.Browser.Firefox) {
                        const frame = dialog.querySelector("#ews-print-preview");

                        if (frame) {
                            frame.focus();
                            frame.contentWindow.print();
                        } else {
                            ECP.Dialog.Alert("Print preview is loading.");
                        }
                    }
                }
            });

            Dialog.firstElementChild.classList.add("ecp-printPreview-dialog");

            const confirmButton = Dialog.querySelector(".ecp-dialog-confirm-button");
            if (EC_Fmt.Browser === ECP.Browser.Firefox) {
                confirmButton.classList.add("disabled");
                confirmButton.parentNode.insertBefore(EC_Fmt.HtmlStrToElement("<span class=firefox-floater-tip></span>"), confirmButton);

                Dialog.querySelector(".firefox-floater-tip").style.display = "block";
            } else {
                confirmButton.parentNode.insertBefore(EC_Fmt.HtmlStrToElement("<span class=floater-tip></span>"), confirmButton);
            }

            const printPreview = Dialog.querySelector("#ews-print-preview");

            const printSettingsForm = Dialog.querySelector("#ews-print-settings-form");
            printSettingsForm.addEventListener("change", (event) => {
                const target = event.target;

                if (target.tagName.toLowerCase() === "input" || target.tagName.toLowerCase() === "select") {
                    // Task 640348: Changing options on the print dialog for a fusion report causes the 'Preview' button to become un-readable
                    printPreview.classList.add("ActionButtonAttention");

                    if (EC_Fmt.Browser !== ECP.Browser.Firefox) {
                        confirmButton.classList.add("disabled");

                        Dialog.querySelector(".floater-tip").style.display = "block";
                    }
                }
            });

            const printPreviewButton = Dialog.querySelector("#ews-print-preview-button");
            printPreviewButton.addEventListener("click", (event) => {
                me.Load();
                event.currentTarget.classList.remove("ActionButtonAttention");

                if (EC_Fmt.Browser !== ECP.Browser.Firefox) {
                    confirmButton.classList.remove("disabled");
                    Dialog.querySelector(".floater-tip").style.display = "none";
                }
            });

            const printDownloadButton = Dialog.querySelector("#ews-print-download-button");

            if (EC_Fmt.Browser !== ECP.Browser.Firefox) {
                printDownloadButton.classList.add("disabled");
            }

            printDownloadButton.addEventListener("click", () => {
                if (EC_Fmt.Browser !== ECP.Browser.Firefox) {
                    const inner = (printPreview.contentDocument || printPreview.contentWindow.document);
                    const url = inner.getElementById("raw-pdf").getAttribute("src");

                    const printPreviewResult = new ECP.EC_Request("GetPrintPreviewResult");
                    printPreviewResult.SetReturnType(ECP.EC_ReturnType.Text);

                    printPreviewResult.AddRequestVariable("Request", "FileURL");
                    printPreviewResult.AddRequestVariable("Url", url);
                    printPreviewResult.Submit().then((resultURL) => {
                        let title = document.getElementsByTagName("title");
                        if (title.length > 0) {
                            title = title[0].innerHTML;
                        }

                        let downloadUrl = `api?APICommand=GetPrintPreviewResult&Request=Download&Url=${url}`;
                        if (resultURL) {
                            downloadUrl = resultURL.replace("../", "");
                        }

                        EC_Fmt.DownloadFileFromURL(downloadUrl, EC_Fmt.Null2EmptyStr(title));
                    });
                } else {
                    ECP.Dialog.Alert("Download Not Supported in Firefox");
                }
            });

            Dialog.querySelector("#ews-print-next-page-button").addEventListener("click", () => {
                if (printPreview?.getAttribute("src") !== "about:blank") {
                    printPreview.contentWindow.NextPage();
                }
            });

            Dialog.querySelector("#ews-print-previous-page-button").addEventListener("click", () => {
                if (printPreview?.getAttribute("src") !== "about:blank") {
                    frame.contentWindow.PreviousPage();
                }
            });

            printPreview.src = "about:blank";

            me.Dialog = Dialog;
            me.File = printArgs.file;
            me.Type = printArgs.type;
            me.Report = printArgs.report;

            if (printArgs.processUrlCallback) {
                me.File = printArgs.processUrlCallback(me.File, "Print");
            }

            if (printArgs.type === "XLSX") {
                printSettingsForm.querySelectorAll("input, select, table").forEach((input) => {
                    input.disabled = false;
                });

                printPreviewButton.style.display = "";
                printDownloadButton.style.display = "block";

                const printPreviewResult = new ECP.EC_Request("GetPrintPreviewResult");
                printPreviewResult.AddRequestVariable("Request", "PrintSettings");
                printPreviewResult.AddRequestVariable("FileName", printArgs.file, ECP.EC_Verb.Post);
                if (printArgs.report && printArgs.report >= 0) {
                    printPreviewResult.AddRequestVariable("ReportID", printArgs.report);
                }
                if (printArgs.master === true) {
                    printPreviewResult.AddRequestVariable("FromMaster", "True");
                }

                const printResult = await printPreviewResult.Submit();

                Dialog.querySelector("#ews-print-grid").checked = printResult.grid;
                Dialog.querySelector("#ews-print-break").checked = printResult.break;

                Dialog.querySelector("#ews-print-size").value = printResult.size;
                Dialog.querySelector("#ews-print-orientation").value = printResult.orientation;
                Dialog.querySelector("#ews-print-scale").value = printResult.scale;
                Dialog.querySelector("#ews-print-margin").value = printResult.margin;

                Dialog.querySelector("#ews-print-header-top-left").value = printResult.header.top.left;
                Dialog.querySelector("#ews-print-header-top-right").value = printResult.header.top.right;
                Dialog.querySelector("#ews-print-header-bottom-left").value = printResult.header.bottom.left;
                Dialog.querySelector("#ews-print-header-bottom-right").value = printResult.header.bottom.right;

                const printSheet = Dialog.querySelector("#ews-print-sheet");
                if (printResult.sheet && printResult.sheet.length > 0) {
                    let html = `<option>${printResult.allSheets}</option>`;

                    for (let i = 0; i < printResult.sheet.length; i++) {
                        html += `<option value="${i}">${printResult.sheet[i].name}</option>`;
                    }

                    printSheet.disabled = false;
                    printSheet.innerHTML = html;
                    printSheet.value = "";
                } else {
                    printSheet.disabled = true;
                    printSheet.innerHTML = "";
                    printSheet.value = "";
                }

                if (printResult.sheet && printResult.sheet.length > 0) {
                    printSheet.disabled = false;
                }

                me.Load();
            } else {
                printSettingsForm.querySelectorAll("input, select, table").forEach((input) => {
                    input.disabled = true;
                });

                printPreviewButton.style.display = "none";
                printDownloadButton.style.display = "none";

                printPreview.src = `Controls/PrintPreview.html?file=${encodeURIComponent(`../${me.File}`)}&t=${new Date().getTime()}`;
            }

            Dialog.querySelector(".ecp-dialog-cancel-button").addEventListener("click", () => {
                me.Dialog = false;
                me.File = false;
                me.Type = false;
                me.Report = false;
            });
        }, true, null, () => {
            // Task 604081: Export and print buttons do nothing on Quicklinks reports - Add option to login when clicking those buttons
            ECP.Dialog.ShowDialog("Confirm", `<div style=font-size:16px;margin:auto;min-height:117px;display:flex;flex-direction:column;align-items:center;justify-content:center><span>You are impersonating a user.</span></span>Do you want to leave and go back to your login?</span></div>`, {
                cancelButtonTitle: "Cancel",
                confirmButtonTitle: "OK",
                confirmButtonAction: () => {
                    window.location.href = `Home?DashboardID=${ECP.CommonDashboards.LogOn}&DestURL=${encodeURIComponent(window.location.href)}`;
                }
            });
        });
    } else {
        ECP.Dialog.Alert("This page needs to be a saved to print. Please click Save Report before printing.");
    }
};

(function (EWS) {
    // eslint-disable-next-line no-shadow
    EWS.Ready((EWS) => {
        EWS.PrintPreview = new BC_PrintPreview(EWS);
    });
}(EWS));

function Print_Preview(file, type, report, master, processUrlCallback) {
    if (EWS?.PrintPreview) {
        EWS.PrintPreview.Print(file, type, report, master, processUrlCallback);
    }
}
